import axios from 'axios'
import agreement from "../../agreements/_getters/agreement";

export default function (context, val) {
  let form = context.state.form;
  let settings = context.rootState.user.setting.items;
  context.dispatch('set_title', 'Редактирование платежа №' + val.id, {root: true});

  axios({
    method: 'get',
    url: '/tourclient/payment/getPayment?ID=' + val.id + '&_=' + new Date().getTime(),
    requestId: 'tourclient/payment/getPayment'
  }).then(r => {
    context.commit('set_load', {
      data: false,
    });
    let data = r.data.Payment;
    if (r.data.ResultQueryInfo.HasError) {
      context.state.system.none = true;
    }

    context.state.system.manager = data.Manager ? data.Manager : '';
    context.state.system.PaySystemType = data.PaySystemDocumentNumber ? data.PaySystemType : '';
    context.state.system.createDate = data.CreateDate ? data.CreateDate.Serialized : '';

    form.Id = val.id;
    form.reports = r.data.ReportsList;
    form.AdditionalValues = r.data.AdditionalValues ? r.data.AdditionalValues : [];
    form.CertificateId = data.CertificateId ? data.CertificateId : '';
    form.CertificateName = data.CertificateId ? (data.CertificateNumber || data.CertificateId) : '';
    form.PaymentDirection = data.Direction - 1;
    form.PaymentOperationID = data.PaymentOperationID;
    form.RateArticleId = data.RateArticleId;
    form.CategoryId = context.rootGetters['dictionary/paymentType/getById'](data.PaymentTypeId).CategoryId;
    form.PaymentTypeId = data.PaymentTypeId;
    form.CashId = data.CashId;
    form.PaymentAccountId = data.PaymentAccountId;
    form.AccountNumber = data.AccountNumber;
    form.ContragentType = data.ContragentType;
    form.ContragentID = data.ContragentID;
    form.BankCommission = data.BankCommission || 0;
    form.ContragentName = data.ContragentName;
    form.PartnerLegalEntityId = data.PartnerLegalEntityId ? data.PartnerLegalEntityId : 0;
    form.PartnerLegalEntityName = data.PartnerLegalEntityName ? data.PartnerLegalEntityName : '';
    if (form.PartnerLegalEntityId) {
      context.state.options.legals = [{
        value: form.PartnerLegalEntityId,
        label: form.PartnerLegalName || data.PartnerLegalEntityName,
      }];
    }
    form.Sum = Math.abs(data.Sum);
    form.CurrencyId = data.CurrencyId;
    form.DocumentNumber = data.DocumentNumber;
    form.PaymentFor = data.PaymentFor;
    form.Comment = data.Comment;
    form.PaymentDate = data.PaymentDate.Serialized;
    if (data.RegularPayments && data.RegularPayments.length) {
      data.RegularPayments.forEach(reg => {
        context.dispatch('regulars/get', {
          id: reg.RegularPaymentId,
          callback: () => {
            let regular = context.getters['regulars/regular'](reg.RegularPaymentId);
            regular.sum = reg.Spread;
            (regular.agreements.filter(i => !data.PaymentDetails.filter(j => j.Code === i)[0])).forEach(i => {
              context.getters['agreements/agreement'](i).requests.forEach(i => {
                i.sum = 0;
              });
            });
            if (data.PaymentDetails.length) {
              data.PaymentDetails.forEach(i => {
                let agreement = context.getters['agreements/agreement'](i.Code);
                agreement.ag.course = i.Course ? i.Course : 1;
                if (form.ContragentType === 3) {
                  if (i.OrderPrices) i.OrderPrices.forEach(j => {
                    agreement.requests.forEach(l => {
                      if (j.RequestId === l.value) {
                        let sum = Math.round(j.Spread / agreement.ag.course * 100) / 100;
                        l.sum = sum;
                      }
                    });
                  });
                } else {
                  if (agreement.requests[0]) agreement.requests[0].sum = Math.round(i.Spread / agreement.ag.course * 100) / 100;
                }
                agreement.ag.comment = i.Comment;
                if (i.Date) agreement.ag.date = i.Date.Serialized;
              })
            }
          }
        });
      });
    } else if (data.PaymentDetails.length) {
      let agreements = [];
      data.PaymentDetails.forEach(i => {
        agreements.push(i.Code);
        context.dispatch('agreements/add', {
          id: i.Code,
          cId: form.CertificateId ? form.ContragentID : '',
          cName: form.CertificateId ? form.ContragentName : '',
          cLegalId: form.CertificateId ? form.PartnerLegalEntityId : '',
          cLegalName: form.CertificateId ? form.PartnerLegalEntityName : '',
          cType: form.CertificateId ? form.ContragentType : '',
          CarryOverOfFunds: i.CarryOverOfFunds,
          callback: agreement => {
            agreement.ag.course = i.Course ? i.Course : 1;
            if (form.ContragentType === 3) {
              if (i.OrderPrices) i.OrderPrices.forEach(j => {
                agreement.requests.forEach(l => {
                  if (j.RequestId === l.value) {
                    let sum = Math.round(j.Spread / agreement.ag.course * 100) / 100;
                    if (form.PaymentDirection) {
                      l.out += sum;
                      l.inp -= sum;
                    } else {
                      l.inp += sum;
                      l.out -= sum;
                    }
                    l.sum = sum;
                  }
                });
              });
            } else {
              if (agreement.requests[0]) {
                let sum = Math.round(i.Spread / agreement.ag.course * 100) / 100;
                if (form.PaymentDirection) {
                  agreement.requests[0].out += sum;
                  agreement.requests[0].inp -= sum;
                } else {
                  agreement.requests[0].inp += sum;
                  agreement.requests[0].out -= sum;
                }
                agreement.requests[0].sum = sum;
              }
            }
            agreement.ag.comment = i.Comment;
            if (i.Date) agreement.ag.date = i.Date.Serialized;
          }
        });
      })
    }
  });
  context.dispatch('files/get', val.id);
}
